import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  Injectable,
} from "@angular/core";
import { Observable } from "rxjs";

import {
  AlertController,
  IonButton,
  IonMenu,
  iosTransitionAnimation,
  MenuController,
  ModalController,
  Platform,
  ToastController,
} from "@ionic/angular";
import { ConfigurationService } from "src/app/services/configuration.service";

import { ItemCart } from "../../../../interfaces/itemCart.interface";
import { Cart } from "../../../../models/cart/cart.model";
import { CartService } from "../../../../services/cart.service";
import { Utils } from "../../../../shared/util";
import { V2ItemPage } from "../v2-item/v2-item.page";
import { ToastaddService } from "src/app/services/toastadd.service";
import { RestaurantService } from "src/app/services/restaurant.service";
import { UsergestorService } from "src/app/services/usergestor.service";
import { Router } from "@angular/router";
import { LoadingController } from '@ionic/angular';


@Component({
  selector: "app-side-cart",
  templateUrl: "./side-cart.component.html",
  styleUrls: ["./side-cart.component.scss"],
})
@Injectable()
export class SideCartComponent implements OnInit, AfterViewInit {
  sideCart: IonMenu;
  cart: Cart;
  public platformUserInfoClass: string;
  public appMode$: Observable<string>;
  public isMenuOpen: boolean = false;


  minOrder: boolean = true;
  finishOrderLabel: any = "ENVIAR PEDIDO";
  loading:  HTMLIonLoadingElement;

  constructor(
    private alertController: AlertController,
    private alerta: ToastaddService,
    private cartService: CartService,
    private config: ConfigurationService,
    private menuCtrl: MenuController,
    private modalController: ModalController,
    private restService: RestaurantService,
    private utils: Utils,
    private toastAdd: ToastaddService,
    private userGestorController: UsergestorService,
    private router: Router,
    private loadingController: LoadingController,

    platform: Platform
  ) {
    const os: "android" | "ios" =
      platform.is("iphone") || platform.is("ipad") ? "ios" : "android";
    this.platformUserInfoClass = platform.is("mobileweb") ? `web-${os}` : os;



  }

  ngOnInit() {
    this.cart = this.cartService.getCart();
    this.appMode$ = this.config.getMode();
    console.log(
      "Carrinho:",
      this.cart,
      (this.appMode$ = this.config.getMode())
    );
  }

  async ngAfterViewInit() {
    this.sideCart = document.getElementById("side-cart") as any;

    // ESCUTA QUANDO A COMANDA FOR LIDA E DISPARA O LOADING
    this.config.comandaScanConcluido$.subscribe(async (concluido) => {
      if (concluido) {
        this.config.comandaScanConcluido$.next(false);  

         this.loading = await this.presentLoading("Processando seu pedido");

      }
    });

  }

  getTotalPrice() {
    return this.cartService.getTotalValue();
  }

  showDetails(item: ItemCart) {
    this.modalController
      .create({
        component: V2ItemPage,
        componentProps: {
          itemCart: item,
        },
        cssClass: "modal-fullscreen",
      })
      .then((modal) => modal.present());
    console.log("Carrinho:", this.cart);
  }

  closeCart() {
    this.modalController.dismiss();
  }


  async doOrder() {

    const confirmBtn: IonButton = document.getElementById("order-confirm-button") as any;
    confirmBtn.disabled = true;

    this.toastAdd.closeToast();

    this.cartService.sendOrderV2().subscribe({
      next: async (result) => {

        confirmBtn.disabled = this.canFinish();

        this.sideCart.close().finally(() => {
          if (typeof result == "string") {
            this.alerta.alertaMsg(
              "Número\n do pedido: " + result,
              "Pedido enviado com sucesso!"
            );
          } else {
            this.appMode$.subscribe((mode: string) => {
              if (mode === "gestor") {
                this.alertController
                  .create({
                    header: "Prontinho!",
                    message: "Pedido encaminhado! Agora é só aguardar",
                    buttons: [
                      {
                        text: "Acompanhar Pedido",
                        handler: () => {
                          const userGestor =
                            this.userGestorController.getUser();
                          if (userGestor === null) {
                            this.router.navigate(["/v2/conta/login"]);
                          } else {
                            this.router.navigate(["/v2/conta/detalhes"]);
                          }
                        },
                      },
                      {
                        text: "OK",
                        handler: () => this.modalController.dismiss(),
                      },
                    ],
                  })
                  .then((alert) => alert.present());
              } else {
                this.alerta.alertaMsg(
                  "Agora é só aguardar!",
                  "Pedido enviado com sucesso!"
                );
                 this.loading.dismiss();

              }
            });
          }

        });
      },
      error: (err) => {
         this.loading.dismiss();
        confirmBtn.disabled = false;
        console.log(err, "sidecart");
        if (err)
          this.utils.showAlert({
            message: err.error || err.message || err,
          });
      }
    });
  }



  cleanCart() {
    this.cartService.clear();
  }

  canFinish(): boolean {
    this.canOrder();
    return this.cartService.getTotalItems() > 0;
  }

  canOrder() {
    if (this.config.modoApp == "gestor")
      this.minOrder =
        this.restService.getRestaurant().pedidoMinimo <= this.getTotalPrice();

    let min =
      this.restService.getRestaurant().pedidoMinimo - this.getTotalPrice();

    this.finishOrderLabel = this.minOrder
      ? "ENVIAR PEDIDO"
      : "ADICIONE " +
      min.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      }) +
      " PARA FINALIZAR";
  }

  addItem(item: ItemCart) {
    this.cartService.addProductToItem(item.id);
    console.log(item);
  }

  removeItem(item: ItemCart) {
    this.cartService.removeProd(item.id);
  }

  closeSideCart() {
    if (this.menuCtrl.isOpen()) this.menuCtrl.close();
    this.toastAdd.closeToast();
  }

  async presentLoading(message: string) {
    const loading = await this.loadingController.create({
      message: message,
      spinner: 'crescent',
      cssClass: 'fullscreen-loading',
      backdropDismiss: false, // Impede que o usuário feche o loading clicando fora
      translucent: false,
      showBackdrop: true, // Exibe um fundo escuro para bloquear a tela
    });

    await loading.present();
    return loading;
  }






}
